import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { I18nModule } from 'app/core/services/i18n/i18n.module';
import { ValidationModule } from 'app/core/services/validation/validation.module';
import { CommonFeedbackComponent } from './common-feedback.component';
import { IntlModule } from '@progress/kendo-angular-intl';
import { RouterModule } from '@angular/router';
import { AutofocusDirectiveModule } from 'app/shared/directives/autoFocus/autofocus.module';
import { GenericUploadModule } from 'app/shared/components/generic-upload';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    I18nModule,
    TranslateModule,
    ValidationModule,
    GenericUploadModule,
    IntlModule,
    AutofocusDirectiveModule,
    RouterModule,
  ],
  declarations: [CommonFeedbackComponent],
  exports: [CommonFeedbackComponent],
})
export class CommonFeedbackModule {}
